import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import purchaseSimSagas from './inventory/purchaseSim/saga';
import genericSagas from './generic/saga';
import reportsSagas from './reports/saga';
import inventoryTransferSagas from './inventory/inventoryTransfer/saga';
import dealersSagas from './dealer/saga';
import activationSagas from './activation/saga'
import userSagas from './user/saga';
import pageAccessSagas from './pageAccess/saga';
import swapSagas from './swap/saga';
import checkStatusSagas from './checkStatus/saga';
import rechargeSagas from './recharge/saga';
import wifiActivationSagas from './wifiActivation/saga';
import planPriceConfigSagas from './planPriceMapping/saga';



export default function* rootSaga() {
        yield all([
                authSagas(),
                purchaseSimSagas(),
                genericSagas(),
                reportsSagas(),
                inventoryTransferSagas(),
                dealersSagas(),
                activationSagas(),
                userSagas(),
                pageAccessSagas(),
                swapSagas(),
                checkStatusSagas(),
                rechargeSagas(),
                wifiActivationSagas(),
                planPriceConfigSagas(),
        ])
}